const API = {
  listBanner: '/api/v1/banner/list',
  getPeopleTypes: '/api/v1/people/getTypes',
  listPeople: '/api/v1/people/list',
  getPublicationYears: '/api/v1/publication/getYears',
  listPublications: '/api/v1/publication/listAll',
  getPublicationTypes: '/api/v1/publication/getTypes',
  getProtocolTypes: '/api/v1/protocol/getTypes',
  listProtocols: '/api/v1/protocol/list',
  listAlbum: '/api/v1/album/listAllAlbum',
  listPicture: '/api/v1/album/listPicturesById',
  getNewsYears: '/api/v1/news/getYears',
  listNews: '/api/v1/news/listAll',
  listJoin: '/api/v1/join/list'
}

export default API
